
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M92.17 5H41.73a2.83 2.83 0 00-2.83 2.83V22h19.37a7.838 7.838 0 017.768 6.895h16.768a2.539 2.539 0 012.52 2.277 2.487 2.487 0 01-2.384 2.8H66.1v10.055h16.842a2.543 2.543 0 010 5.078H66.1V59.16h16.842a2.543 2.543 0 010 5.078H66.1V73h26.07A2.83 2.83 0 0095 70.17V7.83A2.83 2.83 0 0092.17 5zm-9.228 13.84H50.958a2.543 2.543 0 010-5.078h31.984a2.543 2.543 0 010 5.078zM7.83 95h50.44a2.83 2.83 0 002.83-2.83V29.83A2.83 2.83 0 0058.27 27H7.83A2.83 2.83 0 005 29.83v62.34A2.83 2.83 0 007.83 95zm9.228-59.238h31.984a2.543 2.543 0 010 5.078H17.058a2.543 2.543 0 010-5.078zm34.367 17.41a2.487 2.487 0 01-2.383 2.8H17.194a2.539 2.539 0 01-2.52-2.277 2.487 2.487 0 012.384-2.8h31.848a2.539 2.539 0 012.519 2.277zM17.058 66.027h31.984a2.543 2.543 0 010 5.078H17.058a2.543 2.543 0 010-5.078zm0 15.133h31.984a2.543 2.543 0 010 5.078H17.058a2.543 2.543 0 010-5.078z"}})])
          )
        }
      }
    